import { match as country } from "../../../src/params/country.ts";
import { match as language } from "../../../src/params/language.ts";

export const matchers = { country, language };